import API from "shared/services/Api";
import { IDeclaration } from "shared/types/Declaration";

export const sendDeclaration = async (data: IDeclaration, userId: string) =>
  API.post(`oc/referrals/declaration?id=${userId}`, data);
